import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { TablePanel, UserAvatar, RankBadge } from "components/common";
import { callGetApiWithAuth } from "utils/api";
import { asVolume } from "utils/text";

export default function PeQvCard(props) {
  const myUser = useSelector((state) => state.auth.user);
  const [rank, setRank] = useState(undefined);
  const [nextRank, setNextRank] = useState(undefined);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 100,
    total: 0,
  });

  const [rankStat, setRankStat] = useState();
  const [tableData1, setTableData1] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [paginationParam1, setPaginationParam1] = useState({
    currentPage: 1,
    perPage: 100,
    total: 0,
  });

  const onGetRankData = (res) => {
    setRank(res.data.rank);
    setNextRank(res.data.next_rank);
  };
  const onFailRankDdata = () => {};
  const loadRankData = () => {
    callGetApiWithAuth(
      `my_rank/rank_tracker/builder_rank/rank?view_mode=${props.viewMode}`,
      onGetRankData,
      onFailRankDdata
    );
  };

  const onGetListData = (res) => {
    setIsLoading(false);
    setTableData(res.data.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
  };
  const onFailListData = () => {
    setIsLoading(false);
  };
  const loadListData = (paginationParam0) => {
    const params = {
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    setIsLoading(true);
    if (props.viewMode == "current") {
      callGetApiWithAuth(
        `my_rank/rank_tracker/builder_rank/pdownline_op?${q}`,
        onGetListData,
        onFailListData
      );
    } else if (props.viewMode == "last") {
      callGetApiWithAuth(
        `my_rank/rank_tracker/builder_rank/last_pdownline_op?${q}`,
        onGetListData,
        onFailListData
      );
    }
  };

  const onGetCustomerListData = (res) => {
    setIsLoading1(false);
    setTableData1(res.data.data);
    setPaginationParam1({
      ...paginationParam1,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
  };
  const onFailCustomerListData = () => {
    setIsLoading1(false);
  };
  const loadCustomerListData = (paginationParam0) => {
    const params = {
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    setIsLoading1(true);
    callGetApiWithAuth(
      `my_rank/rank_tracker/builder_rank/last_pdownline_op_customer?${q}`,
      onGetCustomerListData,
      onFailCustomerListData
    );
  };
  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadListData(paginationParam0);
  };

  const onPageChange1 = (page) => {
    const paginationParam0 = {
      ...paginationParam1,
      currentPage: page,
    };
    loadCustomerListData(paginationParam0);
  };

  const onGetStatData = (res) => {
    setRankStat(res.data);
  }

  const onFailStatData = () => {}

  useEffect(() => {
    if (props.viewMode) {
      const paginationParam0 = {
        ...paginationParam,
        currentPage: 1,
      };
      loadListData(paginationParam0);
      loadRankData();

      if (props.viewMode == "last") {
        const paginationParam0 = {
          ...paginationParam1,
          currentPage: 1,
        };
        loadCustomerListData(paginationParam0);
      }

      callGetApiWithAuth(
        "my_rank/rank_tracker/builder_rank/last_rank_stats",
        onGetStatData,
        onFailStatData
      );
    }
  }, [props.viewMode]);

  return (
    <>
      <TablePanel
        title={
         "My Placement Tree"
        }
        loading={isLoading}
        data={[{
          first_name: "MP + CP",
          last_name: "",
          mp :  props.viewMode == "current" ? myUser.qualification.mp : rankStat.mp,
          op:  props.viewMode == "current" ? myUser.qualification.mp * 1 + myUser.qualification.cp * 1 : rankStat.mp * 1 + rankStat.cp * 1,
        }, ...tableData]}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        columns={[
          {
            title: "User ID",
            render: (_, record) => <span>#{record.uuid}</span>,
          },
          {
            title: "Name",
            render: (_, record) => (
              <UserAvatar
                image={record.image}
                title={`${record.first_name} ${record.last_name}`}
              />
            ),
          },
          {
            title: "Builder Rank",
            key: "builder_rank_id",
            render: (_, record) => (
              <RankBadge label={record.builder_rank?record.builder_rank.name:'Unranked'} />
            ),
          },
          {
            title: "Marketer Points",
            align: "center",
            render: (_, record) => <span>{asVolume(record.mp)}</span>,
          },
          {
            title: "Total Organization Point",
            align: "center",
            render: (_, record) => <span>{asVolume(record.op * 1)}</span>,
          },
          {
            title: `Adjusted Point (${
              rank && rank.settings.op_limit
                ? asVolume(rank.settings.op_limit)
                : 0
            } Points Max)`,
            align: "center",
            render: (_, record) => (
              <span>
                {rank && rank.settings.op_limit
                  ? asVolume(Math.min(record.op * 1, rank.settings.op_limit))
                  : 0}
              </span>
            ),
          },
          {
            title: `Next Rank(${nextRank?.name}) Adjusted Point (${
              nextRank?.settings.op_limit
                ? asVolume(nextRank.settings.op_limit)
                : 0
            } Points Max)`,
            align: "center",
            render: (_, record) => (
              <span>
                {nextRank?.settings.op_limit
                  ? asVolume(
                      Math.min(record.op * 1, nextRank.settings.op_limit)
                    )
                  : 0}
              </span>
            ),
          },
        ]}
      />

      {/* {props.viewMode == "last" && (
        <TablePanel
          title={"My Placement Tree [Customer]"}
          loading={isLoading1}
          data={tableData1}
          paginationParam={paginationParam1}
          onPageChange={onPageChange1}
          columns={[
            {
              title: "User ID",
              render: (_, record) => <span>#{record.uuid}</span>,
            },
            {
              title: "Name",
              render: (_, record) => (
                <UserAvatar
                  image={record.image}
                  title={`${record.first_name} ${record.last_name}`}
                />
              ),
            },
            {
              title: "Marketer Points",
              align: "center",
              render: (_, record) => <span>{asVolume(record.pv)}</span>,
            },
            {
              title: "Total Organization Points",
              align: "center",
              render: (_, record) => <span>{asVolume(record.op * 1)}</span>,
            },
            {
              title: `Adjusted Points (${
                rank && rank.settings.op_limit
                  ? asVolume(rank.settings.op_limit)
                  : 0
              } Points Max)`,
              align: "center",
              render: (_, record) => (
                <span>
                  {rank && rank.settings.op_limit
                    ? asVolume(Math.min(record.op * 1, rank.settings.op_limit))
                    : 0}
                </span>
              ),
            },
            {
              title: `Next Rank(${nextRank?.name}) Adjusted Point (${
                nextRank?.settings.op_limit
                  ? asVolume(nextRank.settings.op_limit)
                  : 0
              } Points Max)`,
              align: "center",
              render: (_, record) => (
                <span>
                  {nextRank?.settings.op_limit
                    ? asVolume(
                        Math.min(record.op * 1, nextRank.settings.op_limit)
                      )
                    : 0}
                </span>
              ),
            },
          ]}
        />
      )} */}
    </>
  );
}
